import { render, staticRenderFns } from "./channelFilterSelect.vue?vue&type=template&id=9865cfd6"
import script from "./channelFilterSelect.vue?vue&type=script&lang=js"
export * from "./channelFilterSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports